module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAUCAYAAAAKuPQLAAAAAXNSR0IArs4c6QAAAFFJREFUSA3t0KENwDAQxdC0K3WC7N9uFCmFZsYBPmTpk9O79pzPWOsd59x3n/MLn/QUFl5JuQ9rUlh4JeU+rElh4ZWU+7AmhYVXUu7DmhQWXj/CewVtt3IokwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart5-icon/low Glucose.png
// module id = 315
// module chunks = 7